import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
const rows = [{
  have: 'Free videos and drill PDFs',
  gives: 'Drills to search through, one event at a time.',
  adds: 'The full practice for every group: warm-up, drills, main set, strength and cool-down.'
}, {
  have: 'A coaching textbook',
  gives: 'Theory written for serious, experienced programs.',
  adds: 'Practices you can run tomorrow, at three levels, for kids.'
}, {
  have: 'Your school’s meet schedule',
  gives: 'The meet dates and the championship.',
  adds: 'What every group does every day in between, phase by phase.'
}];

/** Shown in place of the second block of reviews until real ones come in. */
export function Alongside() {
  return <section aria-labelledby="alongside-heading" className="w-full bg-navy-mid text-chalk" data-id="element-22" data-mp="xvgb6cfyd93u">
      <div className="mx-auto max-w-5xl px-5 py-16 sm:py-20" data-id="element-23" data-mp="a5lutkwfd2eu">
        <div className="text-center" data-id="element-24" data-mp="66d5qtcbxspm">
          <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-hl" data-id="element-25" data-mp="65bhfn6az9py">Already have resources?</p>
          <h2 id="alongside-heading" className="mt-3 font-display text-3xl text-chalk sm:text-5xl" data-id="element-26" data-mp="22h1bg0385z7l">
            Works alongside what you already use
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm text-chalk/70 sm:text-base" data-id="element-27" data-mp="2ca8evfeen551">
            Videos, drill PDFs and coaching books are a great start. What they
            don&apos;t hand you is today&apos;s practice, built for one coach,
            five event groups and a big team.
          </p>
        </div>

        <ul className="mt-9 grid gap-4 md:grid-cols-3" data-id="element-28" data-mp="1ojusa4el9yhu">
          {rows.map(row => <li key={row.have} className="flex flex-col rounded-2xl border border-navy-line bg-navy p-5 sm:p-6" data-id="element-29" data-mp="1tguprqxdhsxc">
              <p className="text-[11px] font-semibold uppercase tracking-widest text-chalk/55" data-id="element-30" data-mp="1yitwnasbn7z1">You have</p>
              <h3 className="mt-1 font-display text-lg font-bold uppercase leading-tight text-chalk" data-id="element-31" data-mp="34zp4646qa5x1">{row.have}</h3>
              <p className="mt-1.5 text-sm text-chalk/65" data-id="element-32" data-mp="19ufyon0zuy33">{row.gives}</p>
              <div className="mt-4 flex items-start gap-2.5 border-t border-navy-line pt-4" data-id="element-33" data-mp="19sldr8pq35z0">
                <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-hl" data-id="element-34" data-mp="14utoynkdjzz1">
                  <ArrowRightIcon className="h-3 w-3 text-hl-ink" aria-hidden="true" data-id="element-35" data-mp="1it0ar5c1u9ic" />
                </span>
                <p className="text-sm font-medium text-chalk" data-id="element-36" data-mp="1eroj6u9m7e7i">
                  <span className="text-hl" data-id="element-37" data-mp="r4q2bvhl2492">Track Coach Ready adds:</span> {row.adds}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}